import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRootAPI } from "@/api";
import { WebAppPrivileges } from "../pages/Settings/Users/SettingsUsersTable";

export function useUpdateUserPrivileges() {
  const api = useRootAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (args: { userId: string; privileges: WebAppPrivileges }) => {
      return api.updateUserWebAppPrivileges({
        user_id: args.userId,
        body: args.privileges,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}
